// https://github.com/codex-team/editor.js/blob/737ba2abb423665257cf6ccc5e8472742433322f/src/components/inline-tools/inline-tool-link.ts

import * as EditorJS from '@editorjs/editorjs'
import SelectionUtils from "./editor-selection-utils.js"
import { apiUrl, getByAxios } from "../helpers/axios.js"

class LinkInlineTool {
    static isInline = true
    static title = 'Link'

    static get sanitize() {
      return {
        a: {
          href: true,
          rel: 'nofollow',
          target: '_blank',
        },
      }
    }
  
    commandLink = "createLink"
    commandUnlink = "unlink"
    delayTimer = null
  
    ENTER_KEY = 13

    CSS = {
      button: "ce-inline-tool",
      buttonActive: "ce-inline-tool--active",
      buttonModifier: "ce-inline-tool--link",
      buttonUnlink: "ce-inline-tool--unlink",
      input: "ce-inline-tool-input",
      inputShowed: "ce-inline-tool-input--showed"
    }

    nodes = {
      button: null,
      input: null
    }
  

    inputOpened = false
  

    constructor({ api }) {
      this.toolbar = api.toolbar
      this.inlineToolbar = api.inlineToolbar
      this.notifier = api.notifier
      this.selection = new SelectionUtils()
      this.api = api
      this.apiSelection = api.selection
    }
  

    render() {
        this.nodes.button = document.createElement('button');
        this.nodes.button.type = 'button';
        this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier);
        
        const icon1 = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon1.classList.add('icon', 'icon--link');
        icon1.setAttribute('width', 14 + 'px');
        icon1.setAttribute('height', 10 + 'px');
        icon1.setAttribute('viewBox', '0 0 24 24');
        icon1.setAttribute('fill', 'none');
        icon1.innerHTML = `<path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.69998 12.6L7.67896 12.62C6.53993 13.7048 6.52012 15.5155 7.63516 16.625V16.625C8.72293 17.7073 10.4799 17.7102 11.5712 16.6314L13.0263 15.193C14.0703 14.1609 14.2141 12.525 13.3662 11.3266L13.22 11.12"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16.22 11.12L16.3564 10.9805C17.2895 10.0265 17.3478 8.5207 16.4914 7.49733V7.49733C15.5691 6.39509 13.9269 6.25143 12.8271 7.17675L11.3901 8.38588C10.0935 9.47674 9.95706 11.4241 11.0888 12.6852L11.12 12.72"></path>`;

        const icon2 = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon2.classList.add('icon', 'icon--unlink');
        icon2.setAttribute('width', 15 + 'px');
        icon2.setAttribute('height', 11 + 'px');
        icon2.setAttribute('viewBox', '0 0 24 24');
        icon2.setAttribute('fill', 'none');
        icon2.innerHTML = `<path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M15.7795 11.5C15.7795 11.5 16.053 11.1962 16.5497 10.6722C17.4442 9.72856 17.4701 8.2475 16.5781 7.30145V7.30145C15.6482 6.31522 14.0873 6.29227 13.1288 7.25073L11.8796 8.49999"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.24517 12.3883C8.24517 12.3883 7.97171 12.6922 7.47504 13.2161C6.58051 14.1598 6.55467 15.6408 7.44666 16.5869V16.5869C8.37653 17.5731 9.93744 17.5961 10.8959 16.6376L12.1452 15.3883"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17.7802 15.1032L16.597 14.9422C16.0109 14.8624 15.4841 15.3059 15.4627 15.8969L15.4199 17.0818"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6.39064 9.03238L7.58432 9.06668C8.17551 9.08366 8.6522 8.58665 8.61056 7.99669L8.5271 6.81397"></path><line x1="12.1142" x2="11.7" y1="12.2" y2="11.7858" stroke="currentColor" stroke-linecap="round" stroke-width="2"></line>`;

        this.nodes.button.appendChild(icon1);
        this.nodes.button.appendChild(icon2);
        return this.nodes.button;
    }
  

    renderActions() {
      this.nodes.input = document.createElement("input")
      this.nodes.input.placeholder = "Add a link"
      this.nodes.input.classList.add(this.CSS.input)
      this.nodes.input.addEventListener("keydown", event => {
        if (event.keyCode === this.ENTER_KEY) {
          this.enterPressed(event)
        }
      })

      let th = this

      this.nodes.input.addEventListener("keyup", event => {
        let wrapper = null

        wrapper = document.getElementById("ce-inline-toolbar__fast_urls")

        if (!wrapper) {
          wrapper = document.createElement("div")
          wrapper.id = 'ce-inline-toolbar__fast_urls'
          let parent = document.getElementsByClassName("ce-inline-toolbar__actions")[0]
          parent.parentNode.insertBefore( wrapper, parent.nextSibling)
        }

        wrapper.innerHTML = ""

        if (this.nodes.input.value.length >= 1) {
          let lang = $("#esn_news_article_lang").val()
          
          let discipline_id = $("#esn_news_article_game_id").val()
          let params = {
            term: this.nodes.input.value,
            common: true,
            lang: lang,
            discipline_id: discipline_id
          }

          clearTimeout(th.delayTimer)
          
          let wrapper1 = document.createElement("div")
          let wrapper2 = document.createElement("div")
          let wrapper3 = document.createElement("div")
          
          wrapper.appendChild(wrapper1);
          wrapper.appendChild(wrapper2);
          wrapper.appendChild(wrapper3);

          th.delayTimer = setTimeout(function() {
            th.get(th, lang, params, wrapper1, 'events')
            th.get(th, lang, params, wrapper2, 'players')
            th.get(th, lang, params, wrapper3, 'teams')
          }, 300)
        }
      })
      return this.nodes.input
    }

    get(th, lang, params, wrapper, resource) {
      let url = `${apiUrl}/esn_news_articles/${resource}.json`
      let data = getByAxios(require('axios'), url, { params: params })
      .then(function (response) {  
        wrapper.innerHTML = ""     
        if (response.data.length > 0) {
          let header = document.createElement('div')
          header.innerHTML = resource.charAt(0).toUpperCase() + resource.slice(1)
          header.style = "display: block; font-size: 12px; text-color: #b3b3b3; padding: 0px 10px; border-top: 1px; border-bottom: 1px;"
          wrapper.appendChild(header)
        }
        response.data.forEach((el) => {
          let anchor = document.createElement('a')
          let link_name
          if (resource == 'teams') {
            var img = document.createElement("img")
            img.src = el.flag_icon
            img.style = 'height: 22px; margin-right: 2px'
            anchor.appendChild(img)
            link_name = document.createTextNode(`${el.title} (${el.name})`)
          } else if (resource == 'players') {
            var img = document.createElement("img")
            img.src = el.flag_icon
            img.style = 'height: 23px; margin-right: 2px'
            anchor.appendChild(img)
            if (el.name) {
              link_name = document.createTextNode(`${el.title} (${el.name})`)
            } else {
              link_name = document.createTextNode(el.title)
            }
            
            let i18n = el.i18n_names.find(({ name }) => lang === lang)
            if (i18n) {
              let anchor2 = document.createElement('a')
              var img2 = document.createElement("img")
              img2.src = el.flag_icon
              img2.style = 'height: 22px; margin-right: 2px'
              anchor2.appendChild(img2)
              let link_name2 = document.createTextNode(i18n.name)
              anchor2.appendChild(link_name2)
              anchor2.href = "#"
              anchor2.style = "display: block; font-size: 12px; padding: 0px 10px; border-top: 1px; border-bottom: 1px; font-weight: bold"
              wrapper.appendChild(anchor2)
              anchor2.addEventListener("click", event => {
                let url = `${el.domain}/${lang}${el.site_link}`
                th.setLink(event, url, i18n.name)
              })
            }
            
          } else {
            link_name = document.createTextNode(el.name)
          }
          
          anchor.appendChild(link_name)
          anchor.href = "#"
          anchor.style = "display: block; font-size: 12px; padding: 0px 10px; border-top: 1px; border-bottom: 1px;"
          anchor.addEventListener("click", event => {
            let url = `${el.domain}/${lang}${el.site_link}`
            th.setLink(event, url)
          })
          wrapper.appendChild(anchor)
        })
      })
    }


    surround(range) {
      /**
       * Range will be null when user makes second click on the 'link icon' to close opened input
       */
      if (range) {
        /**
         * Save selection before change focus to the input
         */
        if (!this.inputOpened) {
          /** Create blue background instead of selection */
          this.selection.setFakeBackground()
          this.selection.save()
        } else {
          this.selection.restore()
          this.selection.removeFakeBackground()
        }
        const parentAnchor = this.selection.findParentTag("A")
  
        /**
         * Unlink icon pressed
         */
        if (parentAnchor) {
          this.selection.expandToTag(parentAnchor)
          this.unlink()
          this.closeActions()
          this.checkState()
          this.toolbar.close()
          return
        }
      }
  
      this.toggleActions()
    }
  

    checkState(selection) {
      const anchorTag = this.selection.findParentTag("A")

  
      if (anchorTag) {
        this.nodes.button.classList.add(this.CSS.buttonUnlink)
        this.nodes.button.classList.add(this.CSS.buttonActive)
        this.openActions()
  
        /**
         * Fill input value with link href
         */
        const hrefAttr = anchorTag.getAttribute("href")
        this.nodes.input.value = hrefAttr !== "null" ? hrefAttr : ""
  
        this.selection.save()
      } else {
        this.nodes.button.classList.remove(this.CSS.buttonUnlink)
        this.nodes.button.classList.remove(this.CSS.buttonActive)
      }
  
      return !!anchorTag
    }
  

    clear() {
      this.closeActions()
    }
  

    get shortcut() {
      return "CMD+K"
    }
  
    toggleActions() {
      if (!this.inputOpened) {
        this.openActions(true)
      } else {
        this.closeActions(false)
      }
    }
  
    openActions(needFocus = false) {
      this.nodes.input.classList.add(this.CSS.inputShowed)
      if (needFocus) {
        this.nodes.input.focus()
      }
      this.inputOpened = true
    }
  
    /**
     * Close input
     * @param {boolean} clearSavedSelection — we don't need to clear saved selection
     *                                        on toggle-clicks on the icon of opened Toolbar
     */
    closeActions(clearSavedSelection = true) {
      if (this.selection.isFakeBackgroundEnabled) {
        // if actions is broken by other selection We need to save new selection
        const currentSelection = new SelectionUtils()
        currentSelection.save()
  
        this.selection.restore()
        this.selection.removeFakeBackground()
  
        // and recover new selection after removing fake background
        currentSelection.restore()
      }
  
      this.nodes.input.classList.remove(this.CSS.inputShowed)
      this.nodes.input.value = ""
      if (clearSavedSelection) {
        this.selection.clearSaved()
      }
      this.inputOpened = false
    }
  

    enterPressed(event) {
      let value = this.nodes.input.value || ""
      this.setLink(event, value)
    }
    
    setLink(event, value, name=null) {
      
      if (!value.trim()) {
        this.selection.restore()
        this.unlink()
        event.preventDefault()
        this.closeActions()
      }
  
      if (!this.validateURL(value)) {
        this.notifier.show({
          message: "Pasted link is not valid.",
          style: "error"
        })
  
        _.log("Incorrect Link pasted", "warn", value)
        return
      }
  
      value = this.prepareLink(value)
  
      this.selection.restore()
      this.selection.removeFakeBackground()
  
      this.insertLink(value, name)
  
      event.preventDefault()
      event.stopPropagation()
      event.stopImmediatePropagation()
      this.selection.collapseToEnd()
      this.inlineToolbar.close()
      document.getElementById("ce-inline-toolbar__fast_urls").innerHTML = ""
    }
  
    /**
     * Detects if passed string is URL
     * @param  {string}  str
     * @return {Boolean}
     */
    validateURL(str) {
      /**
       * Don't allow spaces
       */
      return !/\s/.test(str)
    }
  
    /**
     * Process link before injection
     * - sanitize
     * - add protocol for links like 'google.com'
     * @param {string} link - raw user input
     */
    prepareLink(link) {
      link = link.trim()
      link = this.addProtocol(link)
      return link
    }
  
    /**
     * Add 'http' protocol to the links like 'vc.ru', 'google.com'
     * @param {String} link
     */
    addProtocol(link) {
      /**
       * If protocol already exists, do nothing
       */
      if (/^(\w+):(\/\/)?/.test(link)) {
        return link
      }
  
      /**
       * We need to add missed HTTP protocol to the link, but skip 2 cases:
       *     1) Internal links like "/general"
       *     2) Anchors looks like "#results"
       *     3) Protocol-relative URLs like "//google.com"
       */
      const isInternal = /^\/[^\/\s]/.test(link),
        isAnchor = link.substring(0, 1) === "#",
        isProtocolRelative = /^\/\/[^\/\s]/.test(link)
  
      if (!isInternal && !isAnchor && !isProtocolRelative) {
        link = "http://" + link
      }
  
      return link
    }
  
    /**
     * Inserts <a> tag with "href"
     * @param {string} link - "href" value
     */
    insertLink(link, name) {
      /**
       * Edit all link, not selected part
       */
      const anchorTag = this.selection.findParentTag("A")
  
      if (anchorTag) {
        this.selection.expandToTag(anchorTag)
      }

      if (name) {
        link = `<a href="${link}">${name}</a>` 
        document.execCommand('insertHTML', false, link)
      } else {
        document.execCommand(this.commandLink, false, link)
      }
  
      
    }
  
    /**
     * Removes <a> tag
     */
    unlink() {
      document.execCommand(this.commandUnlink)
    }

}

export default LinkInlineTool;